<template>
  <div class="home">
    <EventCard v-for="event in events" :key="event.id" :event="event" />
  </div>
</template>

<script>
// @ is an alias to /src
import EventCard from '@/components/EventCard.vue'
import EventService from '@/services/EventServices.js'

export default {
  name: 'EventList',
  components: {
    EventCard,
  },
  data() {
    return {
      events: null,
    }
  },
  // lifecycle Hook
  created() {
    EventService.getEvents()  // fetch data from baseURL defined in EventServices.js
      // axios works async so if the data has been fetched .then() ...
      .then((response) => {
        this.events = response.data
      })
      .catch(error => {
        console.log(error)
      })
  },
}
</script>
